export default __webpack_public_path__ + "static/media/286.83fc2824.svg";